<div class="inner">
    <p-chart type="bar" [data]="data" [options]="options" height="270px"></p-chart>
    <div *ngIf="options.emptyChart" class="not-enough-block">
        Not enough data
    </div>
</div>
